<template>
<footer class="footer">
		<div class="footer_container">
			<div class="container">
				<div class="row">
					
					<!-- Footer - About -->
					<div class="col-lg-4 footer_col">
						<div class="footer_about">
							<div class="footer_logo_container">
								<a href="#" class="d-flex flex-column align-items-center justify-content-center">
									<div class="logo_content">
										<div class="logo d-flex flex-row align-items-center justify-content-center">
											<img src="../assets/img/logo.jpg" width="110" height="110" alt=""/>
										</div>
										
									</div>
								</a>
							</div>
							<div class="footer_about_text">
								<p>We know how crucial it is to find a trustworthy caregiver. That's why we provide ongoing support throughout your caregiving journey.</p>
							</div>
							<ul class="footer_about_list">
								<li><div class="footer_about_icon"><img src="../assets/img/phone-call.svg" alt=""></div><span>770-884-8465 (Office Direct Line)</span></li>
								<li><div class="footer_about_icon"><img src="../assets/img/envelope.svg" alt=""></div><span>info@securedhomecares.com</span></li>
								<li><div class="footer_about_icon"><img src="../assets/img/placeholder.svg" alt=""></div><span>1667 Canton Road Suite B. Marietta Georgia 30066</span></li>
                                <li><router-link to="privacy">Privacy Policy</router-link></li>
							</ul>
						</div>
					</div>

					<!-- Footer - Links -->
					

					<!-- Footer - News -->
					
				</div>
			</div>
		</div>
		<div class="copyright">
			<div class="container">
				<div class="row">
					<div class="col">
						<div class="copyright_content d-flex flex-lg-row flex-column align-items-lg-center justify-content-start">
							<div class="cr">
                                Copyright &copy;2026 All rights reserved | Secured Cares
                            </div>
							<div class="footer_social ml-lg-auto">
								<ul>
									
									<li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
									
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>			
		</div>
	</footer>
</template>